import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MMPLShipCard from "../MMPLShipCard";
import { getMDSearchlist } from "../../Actions/MDlistingAPI";
import "react-datepicker/dist/react-datepicker.css";
import {
  getShipPOByClientId,
  getMMPLShipSearchByClientId,
  getClassFlagData,
  //getShipsByClientId,
} from "../../Actions/MMPLDashboardAPI";
import ShipPOs from "../ShipPOs";
import Moment from "moment";
import CountUp from "react-countup";
import swal from "sweetalert";
import Autocomplete from "react-autocomplete";
import { getShipnameList } from "../../Actions/HelpersAPI";
import { GetKPIData } from "../../Actions/CommonAPI";
import { ExportExcelShip } from "../../Actions/ShipViewAPI";
import axios from "axios";
import API from "../../helpers/api";
import PO from "../../Asset/PO.svg";
import MyPendingTask from "../../Asset/MyPendingTask.svg";
import Awaiting from "../../Asset/Awaiting.svg";
import ShipPendingTask from "../../Asset/ShipPendingTask.svg";
import IHMPending from "../../Asset/IHMPending.svg";
import IHMUpdated from "../../Asset/IHMUpdated.svg";
import shortClosed from "../../Asset/shortClosed.svg";
import Ship from "../../Asset/Ship.svg";
import clear from "../../Asset/clear.svg";
import * as $ from "jquery";
import ShipPOCards from "./ShipCardView";

class PoSyncShips extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialSearch: 1,
      filterTitle: "All Ships",
      showPendingTask: false,
      searchShip: {
        ShipName: "",
        PageSize: 25,
      },
      PageNo: 1,
      PgSize: 25,
      shipId: 0,
      shipName: "",
      poValidationShipName: "",
      isShortClosed: false,
      isIhmPart1: false,
      isAwaitingMdAndSdoc: false,
      isPoValidation: false,
      isShipsPendingTask: false,
      isIhmUpdate2: false,
      isPurchaseOrders: true,
      TotalShip: false,
      shipSuccess: false,

      flag: "",
      class: "",

      clientId: this.props.match.params.id,
      ShipList: [],
      ShipFlagState: [],
      ShipClassState: [],
      shiplListByClientId: [],
      allShips: [],
    };
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleInputChanges = this.handleInputChanges.bind(this);
    this.renderMovieTitle = this.renderMovieTitle.bind(this);
    this.renderLookupTitle = this.renderLookupTitle.bind(this);
    this.SearchShipPOs = this.SearchShipPOs.bind(this);
    this.SearchShips = this.SearchShips.bind(this);
    this.ClearShipSearchField = this.ClearShipSearchField.bind(this);
  }

  componentDidMount() {
    localStorage.removeItem("shipName");
    const { dispatch, SearchResult } = this.props;
    dispatch({ type: "SubBannerTitle", data: "Po Sync Dashboard" });

    let user = JSON.parse(localStorage.getItem("currentUser"));
    // dispatch(getShipPOByClientId(this.state));
    // dispatch(GetKPIData());
    dispatch(getClassFlagData("flag"));
    dispatch(getClassFlagData("class"));
    this.fetchShips();
  }

  fetchShips = () => {
    const params = {
      ClientId: this.state.clientId,
      ShipName: this.state.poValidationShipName || "",
      Flag: this.state.flag || "",
      Class: this.state.class || "",
    };
    axios
      .get(API.PoSyncShips, { params })
      .then((response) => {
        const result = response.data || {};
        const data = result.data || [];
        const mapped = data.map((item) => ({
          shipId: item.shipId,
          shipName: item.shipName,
          enrolledOn: item.enrolledOn,
          lastPulledDate: item.lastPODate,
          totalPo: item.totalPos,
          exceptions: item.totalExceptions,
          isThereIsNo30DaysPo: item.isThereIsNo30DaysPo,
          daysSinceLastPO: item.daysSinceLastPO,
        }));
        const isUnfiltered =
          !this.state.poValidationShipName &&
          !this.state.flag &&
          !this.state.class;
        this.setState({
          shiplListByClientId: mapped,
          allShips: isUnfiltered ? mapped : this.state.allShips,
          initialSearch: 0,
        });
      })
      .catch(() => {
        this.setState({ shiplListByClientId: [], initialSearch: 0 });
      });
  };


  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      dispatch,
      SearchResult,
      ShipPOByClientId,
      ShipFlagData,
      ShipClassData,
    } = nextProps;
    if (nextProps.isMDSearch && nextProps.showSidePane) {
      prevState.searchShip = nextProps.MDSearchData;
    }
    if (nextProps.MDDeleteSuccess && !nextProps.showSidePane) {
      prevState.searchShip = nextProps.MDSearchData;
      dispatch(getMDSearchlist(prevState.searchShip));
    }
    if (ShipPOByClientId) {
      prevState.ShipList = ShipPOByClientId;
    }

    if (ShipFlagData) {
      prevState.ShipFlagState = ShipFlagData;
    }
    if (ShipClassData) {
      prevState.ShipClassState = ShipClassData;
    }
    if (SearchResult && SearchResult !== "" && !prevState.shipSuccess) {
      prevState.poValidationShipName = SearchResult.poValidationShipName;
      prevState.shipName = SearchResult.shipName;
      prevState.isPurchaseOrders = SearchResult.isPurchaseOrders;
      prevState.isShipsPendingTask = SearchResult.isShipsPendingTask;
      prevState.isIhmUpdate2 = SearchResult.isIhmUpdate2;
      prevState.isPoValidation = SearchResult.isPoValidation;
      prevState.isAwaitingMdAndSdoc = SearchResult.isAwaitingMdAndSdoc;
      prevState.isIhmPart1 = SearchResult.isIhmPart1;
      prevState.isShortClosed = SearchResult.isShortClosed;
      prevState.TotalShip = SearchResult.TotalShip;
      prevState.shipSuccess = true;
    }
  }

  ClearPoSearchField() {
    localStorage.removeItem("shipName");
    this.state.initialSearch = 1;
    this.state.poValidationShipName = "";
    this.state.flag = "";
    this.state.class = "";
    // this.props.dispatch(getShipPOByClientId(this.state));
    this.fetchShips();
    this.setState({});
  }
  SearchShips(PgNo) {
    const { dispatch } = this.props;
    dispatch(getMMPLShipSearchByClientId(this.state, PgNo));
  }
  ClearShipSearchField() {
    localStorage.removeItem("shipName");
    this.state.initialSearch = 1;
    this.state.shipName = "";
    this.state.class = "";
    this.state.flag = "";
    this.props.dispatch(
      getMMPLShipSearchByClientId(this.state, this.state.PageNo),
    );
    this.setState({});
  }
  handleShipInputChange(e) {
    this.state.shipName = e.target.value;
    this.setState({});
  }
  SearchShipPOs(action) {
    localStorage.removeItem("shipName");
    this.state.initialSearch = 0;
    const { dispatch } = this.props;
    // dispatch(getShipPOByClientId(this.state));
    this.fetchShips();
  }
  renderMovieTitle(state, val) {
    return state.shipName.toLowerCase().indexOf(val.toLowerCase()) !== -1;
  }
  renderLookupTitle(state, val) {
    return state.toLowerCase().indexOf(val.toLowerCase()) !== -1;
  }
  handleInputChanges(e, field) {
    this.state[field] = e.target.value;
    this.setState({});
  }
  handleSelectChange(value, field) {
    this.state[field] = value;
    this.setState({});
  }

  downloadAwaitingExcel = () => {
    const { dispatch } = this.props;
    dispatch(ExportExcelShip());
    this.setState({});
  };

  hideSidePanel = () => {
    this.props.history.goBack();
    // this.props.dispatch({ type: "POSuccess", data: "" });
  };

  render() {
    const {
      equipmentInfo,
      MMPLSidePanCollectDocs,
      shipMMPLCountByClientId,
      MMPLShipList,
      ShipPOByClientId,
      ShipClassData,
      ShipFlagData,
    } = this.props;

    const {
      isShortClosed,
      isIhmPart1,
      isAwaitingMdAndSdoc,
      isPoValidation,
      isPurchaseOrders,
      TotalShip,
      PurchaseOrders,
      isShipsPendingTask,
      isIhmUpdate2,
      shiplListByClientId,
    } = this.state;

    return (
      <div className="full-height pt-3">
        <button
          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mb-3"
          onClick={() => this.hideSidePanel()}
        >
          &larr; Back
        </button>
        {/* ships */}
        <div
          className=" mb-4 mt-1"
          style={{ backgroundColor: "#F1F5F9", borderRadius: 14 }}
        >
          <>
            <div className="pt-3 px-2 mx-1 row">
              <div className="col-xl-1">
                <label className="label-card">Ships</label>
              </div>
              <div className="col-xl-11 my-auto">
                <div className="row pl-2 prd-4 mbm1rem d-flex justify-content-end">
                  {/* <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3" >
                  </div> */}
                  <div className="autocomplete-wrappers col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 ">
                    <Autocomplete
                      value={this.state.poValidationShipName}
                      // items={this.state.ShipList}
                      items={
                        this.state.allShips.length
                          ? this.state.allShips
                          : this.state.shiplListByClientId
                      }
                      getItemValue={(item) => item.shipName}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Ship Name"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderMovieTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          key={item.shipId}
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item.shipName}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "poValidationShipName")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(value, "poValidationShipName")
                      }
                    />
                  </div>
                  <div className="autocomplete-wrappers col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 ">
                    {/* <input type="text" className="form-control input-border-none" placeholder="Flag" value={this.state.flag} onChange={(e) => this.handleInputChanges(e, "flag")} /> */}
                    <Autocomplete
                      value={this.state.flag}
                      items={this.state.ShipFlagState}
                      getItemValue={(item) => item}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Flag"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderLookupTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "flag")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(value, "flag")
                      }
                    />
                  </div>
                  <div className="autocomplete-wrappers col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 mb-3 prd-3 pl-1  prm-3 ">
                    {/* <input type="text" className="form-control input-border-none" placeholder="Class" value={this.state.class} onChange={(e) => this.handleInputChanges(e, "class")} /> */}
                    <Autocomplete
                      value={this.state.class}
                      items={this.state.ShipClassState}
                      getItemValue={(item) => item}
                      renderInput={(props) => {
                        return (
                          <input
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Class"
                            {...props}
                            style={{ border: "1px solid #ffffff" }}
                          />
                        );
                      }}
                      shouldItemRender={this.renderLookupTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdowns">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${isHighlighted ? "selected-items" : ""
                            }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChanges(e, "class")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(value, "class")
                      }
                    />
                  </div>
                  <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 px-1 px-1 mb-3">
                    <button
                      className="btn btn-primary txtside-btn txtht-btn blue w-50 btnclr"
                      type="submit"
                      onClick={() => this.SearchShipPOs(1)}
                    >
                      {" "}
                      Search{" "}
                    </button>
                    <button
                      className="btn txtside-btn txtht-btn clearbtn w-50 clr-butn"
                      type="button"
                      onClick={() => this.ClearPoSearchField()}
                    >
                      <img
                        className="mb-1"
                        src={clear}
                        width={21}
                        height={21}
                      />{" "}
                      Clear{" "}
                    </button>
                  </div>
                  {/* <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 px-1 mb-3">
                    <button className="btn txtside-btn txtht-btn clearbtn w-100 clr-butn" type="button" onClick={() => this.ClearPoSearchField()}><img className="mb-1" src={clear} width={21} height={21} /> Clear </button>
                  </div> */}
                </div>
              </div>
            </div>

            {shiplListByClientId && shiplListByClientId.length ? (
              <>
                <ShipPOCards
                  arraylist={shiplListByClientId}
                  setUpdatedState={(value) => this.SearchShipPOs(value)}
                />
              </>
            ) : this.state.initialSearch == 0 ? (
              <>
                <div className="mt-0 mb-4 ml-4 mr-4  cardBck row">
                  <div className="col-xl-12">
                    <h6 className="bold-count no-item-card f-size">No Ships</h6>
                  </div>
                </div>
                <div className="pb-1"></div>
              </>
            ) : null}
          </>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    //unused
    ShortClosedSearchResults:
      state.MMPLDashboardReducer.MMPLShortClosedShipSearchResult,
    IHMSearchResults: state.MMPLDashboardReducer.MMPLIHMShipSearchResult,
    mDocSearchResults: state.MMPLDashboardReducer.MMPLMdocShipSearchResult,
    poSearchResult: state.MMPLDashboardReducer.MMPLPOShipSearchResult,
    showMMPLDetailsPane: state.SidePanReducer.ShowMMPLDetails || false,
    shipMMPLInfo: state.MMPLDashboardReducer.MMPLShipInfo || {},
    shipMMPLSearchResult: state.MMPLDashboardReducer.MMPLShipSearchResult || [],
    shipMMPLDetail: state.MMPLDashboardReducer.shipMMPLDetail || {},
    ClientShipDetails: state.SidePanReducer.ClientShipDetails,

    //used
    showSidePane: state.SidePanReducer.sidePan || false,
    arraylist: state.SidePanReducer.arraylist,
    MDDeleteSuccess: state.SidePanReducer.MDDeleteSuccess,
    isMDSearch: state.SidePanReducer.isMDSearch,
    MDSearchData: state.SidePanReducer.MDSearchData,
    MMPLSidePanCollectDocs: state.MMPLDashboardReducer.MMPLSidePanCollectDocs,
    MMPLShipList: state.MMPLDashboardReducer.MMPLShipListByClientId,
    ShipPOByClientId: state.MMPLDashboardReducer.ShipPOsByClientId,
    SearchResult: state.MMPLDashboardReducer.SearchSuccessByClientId,
    shipMMPLCountByClientId: state.MMPLDashboardReducer.ShipMMPLCountByClientId,
    ShipClassData: state.MMPLDashboardReducer.ShipClassData,
    ShipFlagData: state.MMPLDashboardReducer.ShipFlagData,

    //ShipList: state.MMPLDashboardReducer.ShipListByClientId,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PoSyncShips),
);
